import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/services/ServicesClient.tsx");
